<template>
  <v-toolbar dense
             flat
             grow
             class="mb-4">
    <v-tabs>
      <v-tab :to="{name: 'presentation.info', exact: true, params: {presentationID: presentation.id}}">
        Info
      </v-tab>
      <v-tab :to="{name: 'admin.sharing_sessions.index', exact: true, params: {presentationID: presentation.id}}">
        Sharing Sessions
      </v-tab>
      <template v-if="canAdminPresentation">
        <v-spacer></v-spacer>
        <v-tab :to="{name: 'presentation.edit', exact: true, params: {presentationID: presentation.id}}"
               disabled>
          Edit
        </v-tab>
        <v-tab :to="{name: 'presentation.upload', exact: true, params: {presentationID: presentation.id}}">
          Upload
        </v-tab>
        <v-menu bottom
                tile
                disabled
                offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text
                   disabled
                   class="align-self-center mr-4"
                   v-bind="attrs"
                   v-on="on">
              More
              <v-icon right>
                fas fa-caret-down
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item disabled>
              <v-list-item-content>
                Comments
              </v-list-item-content>
            </v-list-item>
            <v-list-item disabled>
              <v-list-item-content>
                Recommendations
              </v-list-item-content>
            </v-list-item>
            <v-list-item disabled>
              <v-list-item-content>
                Files
              </v-list-item-content>
            </v-list-item>
            <v-list-item disabled>
              <v-list-item-content>
                Copy to Team
              </v-list-item-content>
            </v-list-item>
            <v-list-item disabled>
              <v-list-item-content>
                Watchers
              </v-list-item-content>
            </v-list-item>
            <v-list-item disabled>
              <v-list-item-content>
                Change Thumbnail
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-tabs>
  </v-toolbar>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    presentation: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isMember',
      'team',
      'user',
    ]),
    canAdminPresentation() {
      return this.isAdmin || this.presentation.owner_id === this.user.id;
    },
    canBeShared() {
      const presentation = this.presentation;
      const team = this.team;
      const user = this.user;
      return team.sharing_enabled
        && (!presentation.is_private || presentation.owner_id === user.id)
        && (presentation.settings.can_be_shared || presentation.settings.can_be_shared_link)
    }
  }
}
</script>
